var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.973 23.69l18.029-8.95a2.585 2.585 0 013.376 1.007 2.544 2.544 0 01-1.271 3.646L9.032 27.301a1.923 1.923 0 01-1.947-.315l-3.78-3.185a.638.638 0 01.207-1.094l2.426-.827a.65.65 0 01.584.082l2.451 1.728z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.152,
    d: "M8.973 23.69l18.029-8.95a2.585 2.585 0 013.376 1.007 2.544 2.544 0 01-1.271 3.646L9.032 27.301a1.923 1.923 0 01-1.947-.315l-3.78-3.185a.638.638 0 01.207-1.094l2.426-.827a.65.65 0 01.584.082l2.451 1.728z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2C2C2",
    d: "M15.836 20.218l-4.392-2.167a.638.638 0 01-.024-1.134l1.48-.81c.287-.158.627-.2.945-.114l6.764 1.822-4.771 2.404z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.152,
    d: "M15.836 20.218l-4.392-2.167a.638.638 0 01-.024-1.134l1.48-.81c.287-.158.627-.2.945-.114l6.764 1.822-4.771 2.404z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2C2C2",
    d: "M18.384 23.771l-.716 4.944c-.075.515.47.9.935.66l1.935-.993c.292-.15.514-.407.623-.715l2.027-5.823-4.804 1.927z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.152,
    d: "M18.384 23.771l-.716 4.944c-.075.515.47.9.935.66l1.935-.993c.292-.15.514-.407.623-.715l2.027-5.823-4.804 1.927z"
  }))));
}
export default SvgFlight;